export const storageTypes = [
  {
    label: 'Shed',
    value: 'shed',
  },
  {
    label: 'Silo',
    value: 'silo',
  },
  {
    label: 'Paddock',
    value: 'paddock',
  },
  {
    label: 'Other',
    value: 'other',
  }
]
export const tankStorageTypes = [
  { value: "diesel_tank", label: "Diesel Tank" },
  { value: "water_tank", label: "Water Tank" },
  { value: "chemical_tank", label: "Chemical Tank" },
  { value: "fertilizer_tank", label: "Fertilizer Tank" },
  { value: "grain_storage", label: "Grain Storage" },
  { value: "feed_storage", label: "Feed Storage" },
  { value: "fuel_tank", label: "Fuel Tank" },
  { value: "oil_tank", label: "Oil Tank" },
  { value: "other_storage", label: "Other Storage" }
];